{
  "version": 1,
  "asset_id": "fab4ccb0-e7a1-4a1c-820d-9a5f9795422e",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/fab4ccb0-e7a1-4a1c-820d-9a5f9795422e/palworld-playmat.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/fab4ccb0-e7a1-4a1c-820d-9a5f9795422e/palworld-playmat.webp",
  "original_filename": "palworld-playmat.webp",
  "size": 109408,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:36:13Z"
}
